import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useState, useMemo } from "react";
import { Search } from "lucide-react";
import { visibleTools } from "../data/tools";
import { SEO } from "../components/SEO";
import { toolsMeta } from "../seo/meta";

export function ToolsPage() {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState("");

  const filteredTools = useMemo(() => {
    if (!searchQuery.trim()) {
      return visibleTools;
    }

    const query = searchQuery.toLowerCase().trim();
    return visibleTools.filter((tool) => {
      const name = t(`${tool.i18nKey}.name`).toLowerCase();
      const description = t(`${tool.i18nKey}.description`).toLowerCase();
      return name.includes(query) || description.includes(query);
    });
  }, [searchQuery, t]);

  return (
    <>
      <SEO {...toolsMeta(t("tools.allSubtitle"))} />
      <main className="content tools-page">
      <section className="tools-section">
        <h1 className="section-title">{t("tools.allTitle")}</h1>
        <p className="section-subtitle">
          {t("tools.allSubtitle")}
        </p>
        <div className="tools-search-wrapper">
          <div className="tools-search">
            <Search className="tools-search-icon" size={20} />
            <input
              type="text"
              className="tools-search-input"
              placeholder={t("tools.searchPlaceholder")}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
        {filteredTools.length === 0 ? (
          <div className="tools-no-results">
            <p>{t("tools.noResults")}</p>
          </div>
        ) : (
          <div className="tools-grid">
            {filteredTools.map((tool) => (
              <Link
                key={tool.slug}
                to="/tools/$toolSlug"
                params={{ toolSlug: tool.slug }}
                className="tool-card"
              >
                <div className="tool-icon">
                  <tool.Icon className="tool-icon-svg" aria-hidden="true" />
                </div>
                <h3>{t(`${tool.i18nKey}.name`)}</h3>
                <p>{t(`${tool.i18nKey}.description`)}</p>
                <span className="tool-link">{t("tools.openTool")}</span>
              </Link>
            ))}
          </div>
        )}
      </section>
    </main>
    </>
  );
}
